
define('template!webshopFiltersProductsView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (pimWarning) { ;
__p += '\n<div class="pim-warning">' +
((__t = ( _.i18n('webshop.filters.productsPimWarning', null, 'PIM filter: the next PIM sync of a product replaces its links to this filter.') )) == null ? '' : __t) +
'</div>\n';
 } ;
__p += '\n<div class="toolbar">\n    <input type="text" class="search" placeholder="' +
((__t = ( _.i18n('webshop.filters.searchProduct', null, 'Code or label') )) == null ? '' : __t) +
'"/>\n    <div class="add-region"></div>\n</div>\n<div class="list"></div>\n<div class="pager"></div>\n';

}
return __p
};});

